import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { APIS_KEYS } from "../../apis-keys";
import {
  IPropsGetMarketplaceCheckTire,
  IResponseGetMarketplaceCheckTire,
} from "./types";
import { MarketplaceCheckTireURL } from "../../../utils/constants";
import type { AxiosInstance, AxiosResponse } from "axios";
import { useApi } from "../../useApi";

async function getMarketplaceCheckTire(apiPrivate: AxiosInstance) {
  try {
    const response: AxiosResponse<IResponseGetMarketplaceCheckTire> =
      await apiPrivate.get(`${MarketplaceCheckTireURL}`);
    return response.data;
  } catch (error: any) {
    console.log(error);
    throw new Error("something went wrong");
  }
}

export function useGetMarketplaceCheckTire(
  data: IPropsGetMarketplaceCheckTire,
  options?:
    | Omit<
        UseQueryOptions<
          IResponseGetMarketplaceCheckTire,
          unknown,
          IResponseGetMarketplaceCheckTire
        >,
        "queryKey" | "queryFn"
      >
    | undefined
) {
  const { apiPrivate } = useApi();
  return useQuery({
    queryKey: [APIS_KEYS.GETMARKETPLACECHECKTRIE, ...Object.values(data)],
    queryFn: () => getMarketplaceCheckTire(apiPrivate),
    ...options,
  });
}
